import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Premi 'Esporta' per generare i Word o i PDF della verifica. Premi 'Salva nel tuo archivio' per salvare le modifiche apportate alla verifica, in una copia che troverai ne 'Il tuo archivio'.",
        name: 'ModifyEditorialHomeworkPageAnchor',
        tutorialName: 'dettaglio-verifica-editoriale-modifica_pulsantiera'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
